const companyActionTypes = {
  COMPANY_FETCH_REQUEST: 'COMPANY_FETCH_REQUEST',
  COMPANY_SET_DATA: 'COMPANY_SET_DATA',
  COMPANY_SET_ERROR: 'COMAPNY_SET_ERROR',
  COMPANY_REMOVE_ERROR: 'COMPANY_REMOVE_ERROR',
  FETCH_COMPANIES_SUCCESS: 'FETCH_COMPANIES_SUCCESS',
  FETCH_COMPANIES_FAILURE: 'FETCH_COMPANIES_FAILURE',
  FETCH_COMPANIES_BY_PAGGINATION: 'FETCH_COMPANIES_BY_PAGGINATION',
  GET_ALL_COMPANIES_SUCCESS: 'GET_ALL_COMPANIES_SUCCESS',
  COMPANY_START_FETCH: 'COMPANY_START_FETCH',
  FETCH_COMPANY_DETAILS_SUCCESS: 'FETCH_COMPANY_DETAILS_SUCCESS',
  FETCH_COMPANY_DETAILS_FAILURE: 'FETCH_COMPANY_DETAILS_FAILURE',
  UPDATE_COMPANY_SUCCESS: 'UPDATE_COMPANY_SUCCESS',
  UPDATE_COMPANY_FAILURE: 'UPDATE_COMPANY_FAILURE',
  COMPANY_START_FETCH: 'COMPANY_START_FETCH',
  FETCH_COMPANY_DETAILS_SUCCESS: 'FETCH_COMPANY_DETAILS_SUCCESS',
  FETCH_COMPANY_DETAILS_FAILURE: 'FETCH_COMPANY_DETAILS_FAILURE',
  REMOVE_COMPANY_DETAILS_POPUP: 'REMOVE_COMPANY_DETAILS_POPUP',
  COMPANY_DELETE_SUCCESS: 'COMPANY_DELETE_SUCCESS',
  COMPANY_DELETE_FAILURE: 'COMPANY_DELETE_FAILURE',
  COMPANY_DELETE_REMOVE_MESSAGE: 'COMPANY_DELETE_REMOVE_MESSAGE',
  REMOVE_COMPANY_DETAILS_POPUP: 'REMOVE_COMPANY_DETAILS_POPUP',
  GET_COMPANIES_NAME_SUCCESS: 'GET_COMPANIES_NAME_SUCCESS',
  GET_BACKBTN_SUCCESS: 'GET_BACKBTN_SUCCESS',
  GET_BACKBTN_FAILURE: 'GET_BACKBTN_FAILURE',
  GET_ALL_COMPANIES_RESET: 'GET_ALL_COMPANIES_RESET'
};

export default companyActionTypes;
